import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=b4101bcc&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=ts"
export * from "./todoList.vue?vue&type=script&lang=ts"
import style0 from "./todoList.vue?vue&type=style&index=0&id=b4101bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4101bcc",
  null
  
)

export default component.exports